import { useState } from 'react';
import { Col, Container, Row, Modal, Button, Ratio } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import { createUseThemedStyles, useNavigationConfig } from '@/hooks';
import { ReactComponent as DwcMatrixIcon } from '@/assets/icons/hackett-dwc-matrix-icon.svg';
import { ReactComponent as ResearchReportsIcon } from '@/assets/icons/hackett-research-reports-icon.svg';
import { ReactComponent as CustomContentIcon } from '@/assets/icons/hackett-custom-content-icon.svg';
import { ReactComponent as HackettLogo } from '@/assets/logos/logo-hackett.svg';

const useStyles = createUseThemedStyles({
	iconOuter: {
		width: 160,
		height: 'auto',
		display: 'block',
		margin: '0 auto 8px',
	},
});

export const ProcurementTechnologyIntelligence = () => {
	const classes = useStyles();
	const { navigationConfig } = useNavigationConfig();
	const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);

	return (
		<>
			<Helmet>
				<title>Hackett Connect - Procurement Technology Intelligence Program</title>
			</Helmet>

			<Container className="bg-white" fluid>
				<Container className="py-11">
					<Row>
						<Col>
							<h1 className="mb-4 text-primary">Procurement Technology Intelligence Program</h1>
							<p>
								In today's digital, AI-driven world, it isn't enough for vendors of procurement software
								and business process outsourcing services to offer a robust feature set, broad market
								penetration and, in the case of service providers, relevant skill sets and experience.
								Buyers like you want evidence of tangible performance improvement and measurable
								business impact - before you invest.
							</p>
							<p className="mb-0">
								The Hackett Group's Solution Intelligence program supports your procurement software or
								service vendor selection process and enables program members to self-assess their
								pre-implementation planning and post-implementation optimization. Our solution
								intelligence technology analysts and process experts can help you navigate today's
								complex technology landscape.
							</p>
						</Col>
					</Row>
				</Container>
			</Container>

			<Container className="bg-gray-100" fluid>
				<Container className="py-11">
					<Row className="mb-4">
						<Col>
							<h2 className="mb-4 text-primary">Resources Available in Hackett Connect&reg;</h2>
							<p className="mb-0">
								Featured Solution Intelligence for buyers' insights are available in your member
								programs, including:
							</p>
						</Col>
					</Row>
					<Row className="mb-4">
						<Col lg={4} className="mb-4">
							<DwcMatrixIcon className={classNames(classes.iconOuter, 'text-danger')} />
							<h4 className="mb-2 text-uppercase text-danger text-center">
								Software and Service Vendor Assessments
							</h4>
							<p className="mb-0 text-center">
								Grounded in deep process expertise and Digital World Class&reg; performance standards,
								these reports measure how effectively procurement software and service solutions enable
								measurable ROI and enable better business outcomes
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<ResearchReportsIcon className={classNames(classes.iconOuter, 'text-secondary')} />
							<h4 className="mb-2 text-uppercase text-secondary text-center">Vendor Profiles</h4>
							<p className="mb-0 text-center">
								Comprehensive profiles of procurement software and service vendors, including company
								overview, strategic vision, product portfolio, core capabilities, representative clients
								and key partnerships
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<CustomContentIcon className={classNames(classes.iconOuter, 'text-warning')} />
							<h4 className="mb-2 text-uppercase text-warning text-center">
								Solution Intelligence Research
							</h4>
							<p className="mb-0 text-center">
								Procurement vendor SolutionMap evaluations, spotlight reports, market perspectives on
								evolving technological trends, and curated insights from podcasts, webcasts, and major
								vendor conferences and events provide context to stay current, identify emerging
								capabilities, and make more informed decisions
							</p>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="text-center">
								<button
									className="hackett-button hackett-button-secondary"
									type="button"
									onClick={() => {
										setShowLearnMoreModal(true);
									}}
								>
									Learn More
								</button>
							</div>
						</Col>
					</Row>
				</Container>
			</Container>

			<Modal size="lg" centered show={showLearnMoreModal}>
				<Modal.Header>
					<HackettLogo width={190} height={24} />
				</Modal.Header>
				<Modal.Body>
					<Ratio aspectRatio="16x9">
						<video autoPlay width="350" height="auto" controls>
							<source
								src={navigationConfig && navigationConfig.marketIntelligenceLearnMoreVideoUrl}
								type="video/mp4"
							/>
							Your browser does not support the video tag.
						</video>
					</Ratio>
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={() => {
							setShowLearnMoreModal(false);
						}}
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
